var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreV(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_22136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5799 27.805C22.5799 26.3801 21.4248 25.225 19.9999 25.225C18.575 25.225 17.4199 26.3801 17.4199 27.805C17.4199 29.2299 18.575 30.385 19.9999 30.385C21.4248 30.385 22.5799 29.2299 22.5799 27.805Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5799 19.505C22.5799 18.0801 21.4248 16.925 19.9999 16.925C18.575 16.925 17.4199 18.0801 17.4199 19.505C17.4199 20.9299 18.575 22.085 19.9999 22.085C21.4248 22.085 22.5799 20.9299 22.5799 19.505Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5799 11.1949C22.5799 9.77001 21.4248 8.6149 19.9999 8.6149C18.575 8.6149 17.4199 9.77001 17.4199 11.1949C17.4199 12.6198 18.575 13.7749 19.9999 13.7749C21.4248 13.7749 22.5799 12.6198 22.5799 11.1949Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_22136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.77,
    height: 5.16,
    fill: "white",
    transform: "translate(17.4199 30.385) rotate(-90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreV);
export default __webpack_public_path__ + "static/media/more-v.7ae215fa761a0a92b83db00c924a0f4c.svg";
export { ForwardRef as ReactComponent };